var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-address-administration" },
    [
      _c(
        "global-modal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("template", { slot: "header" }, [
            _c("h2", {}, [_vm._v(_vm._s(_vm.$t("titles." + _vm.showView)))]),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "body" },
            [
              _vm.showListView
                ? _c("global-address-administration-list", {
                    attrs: {
                      start: _vm.currentPage * 6,
                      end: _vm.currentPage * 6 + 6,
                      addresses: _vm.addressesSorted,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.changeView(
                          _vm.views.DELETE_VIEW,
                          $event.detail
                        )
                      },
                      edit: function ($event) {
                        return _vm.changeView(
                          _vm.views.EDIT_VIEW,
                          $event.detail
                        )
                      },
                      select: function ($event) {
                        return _vm.selectAddress($event.detail)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showEditView
                ? _c("global-address-administration-edit", {
                    attrs: {
                      errors: _vm.errors,
                      "affected-address": _vm.affectedAddress,
                    },
                    on: {
                      "update:errors": function ($event) {
                        _vm.errors = $event
                      },
                      "update:affectedAddress": function ($event) {
                        _vm.affectedAddress = $event
                      },
                      "update:affected-address": function ($event) {
                        _vm.affectedAddress = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showDeleteView
                ? _c(
                    "global-address-administration-delete",
                    _vm._b(
                      { attrs: { addresses: _vm.addressesSorted } },
                      "global-address-administration-delete",
                      Object.assign(_vm.$props, _vm.$data),
                      false
                    )
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showView === _vm.views.LIST_VIEW
            ? _c(
                "template",
                { slot: "pagination" },
                [
                  _c("global-button", {
                    attrs: {
                      theme: "secondary",
                      icon: "arrow-left",
                      disabled: _vm.currentPage <= 0,
                    },
                    on: {
                      click: function ($event) {
                        _vm.currentPage--
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("global-button", {
                    attrs: {
                      theme: "secondary",
                      icon: "arrow-right",
                      disabled: _vm.currentPage >= _vm.pages,
                    },
                    on: {
                      click: function ($event) {
                        _vm.currentPage++
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showEditView
            ? [
                _c(
                  "global-button",
                  {
                    attrs: { slot: "controls__left", theme: "secondary" },
                    on: { click: _vm.editCancel },
                    slot: "controls__left",
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "global-button",
                  {
                    attrs: { slot: "controls__right", theme: "primary" },
                    on: { click: _vm.editConfirm },
                    slot: "controls__right",
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.save")))]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showListView
            ? [
                _c(
                  "global-button",
                  {
                    attrs: { slot: "controls__left", theme: "secondary" },
                    on: { click: _vm.newAddress },
                    slot: "controls__left",
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.new")))]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showDeleteView
            ? [
                _c(
                  "global-button",
                  {
                    attrs: { slot: "controls__left", theme: "secondary" },
                    on: { click: _vm.deleteCancel },
                    slot: "controls__left",
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "global-button",
                  {
                    attrs: { slot: "controls__right", theme: "primary" },
                    on: { click: _vm.deleteConfirm },
                    slot: "controls__right",
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.delete")))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }